import { translatableZodSchema } from "@@/shared/translations/translation";
import { customerIdZodSchema } from "@@/shared/users/customer-id";
import { userIdZodSchema } from "@@/shared/users/user-id";
import type { Except } from "type-fest";
import { z } from "zod";
import type {
    _OrderEventBaseFactoryParams} from "./_order-base.event";
import {
    _orderEventBaseFactory,
    _orderEventBaseZodObject,
} from "./_order-base.event";

const orderCancelledEventZodSchema = _orderEventBaseZodObject.merge(
    z.object({
        type: z.literal("CANCELLED"),
        reason: translatableZodSchema,
        cancelledBy: userIdZodSchema.or(customerIdZodSchema).optional(),
    }),
);
type OrderCancelledEvent = z.infer<typeof orderCancelledEventZodSchema>;

// Factory params
type FactoryParams = _OrderEventBaseFactoryParams &
    Except<
        OrderCancelledEvent,
        "type" | "_id" | "_type" | "_createdAt" | "signature"
    >;

type Params = Except<FactoryParams, "signature">;
const orderCancelledEventFactory = (params: Params): OrderCancelledEvent => ({
    ..._orderEventBaseFactory({
        orderId: params.orderId,
        orderGroupId: params.orderGroupId,
        _version: params._version,
        providerId: params.providerId,
        providerSlug: params.providerSlug,
        signature: [params.orderId, "CANCELLED"],
    }),

    type: "CANCELLED",
    reason: params.reason,
    cancelledBy: params.cancelledBy,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isOrderCancelledEvent = (event: any): event is OrderCancelledEvent => {
    return (
        !!event && event._type === "ORDER_EVENT" && event?.type === "CANCELLED"
    );
};

export {
    isOrderCancelledEvent,
    orderCancelledEventFactory,
    orderCancelledEventZodSchema,
};
export type { OrderCancelledEvent };
